export interface Props {
    /**
     * @title Conteúdo
     * @format html
     */
    content: string
}

export default function Text({ content }: Props) {
    return (
        <div
            className='institutional-hyperlinks text-black [word-break:break-word] hyphens-auto [&_h1]:mt-3 [&_h1]:mb-8 [&_h1]:text-salmon [&_h1]:text-2xl [&_h1]:font-black [&_h1]:uppercase [&_h2]:mt-8 [&_h2]:mb-4 [&_h2]:text-lg [&_h2]:leading-none [&_h2]:font-bold [&_h2]:underline [&_h2]:uppercase [&_h3]:mt-6 [&_h3]:mb-4 [&_h3]:leading-none [&_h3]:font-bold [&_h3]:uppercase [&_p]:mb-3 [&_p]:text-[15px] [&_p]:font-medium [&_p]:leading-snug [&_p]:text-justify [&_p_b]:font-extrabold [&_p_strong]:font-extrabold'
            dangerouslySetInnerHTML={{ __html: content }}
        />
    )
}
